import Axios from 'axios'

export default {
  getCostCenterBaseUrl() {
    return process.env.VUE_APP_URL_COST_CENTER_BASE
  },
  searchCostCenter (query) {
    return Axios.get(this.getCostCenterBaseUrl() + `api/v1/cost-centers?term=${query}&amount=5`)
  }
}
